import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Const } from '../const';

import { BetweenTimeApiParameter, PastDashboardApiParameter } from '../servicer/models/past-dashboard-api-parameter';
import { BetweenTimeApiResponse } from '../servicer/models/dashboard-api-response';

import { VehicleServiceProvider } from '../servicer/vehicle-service';

/**
 * ダッシュボードを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class BetweenIntervalReceiverProvider {

 

    /** ダッシュボードの空のパラメータ. */
  private readonly dashboardEmptyParameter = {
    // target_domain_name: '',
    sampling_time: null,
    target_start_dt: '',
    target_end_dt: ''
  } as BetweenTimeApiParameter;

    /** ダッシュボードの空のレスポンス. */
  private readonly dashboardEmptyResponse = {
    target_start_dt: '',
    acutual_start_dt: '',
    target_end_dt: '',
    acutual_end_dt: '',
    time_series: null
  } as BetweenTimeApiResponse;

  /** パラメータ情報. */
  public parameter$: BehaviorSubject<BetweenTimeApiParameter> = new BehaviorSubject<BetweenTimeApiParameter>(this.dashboardEmptyParameter);
  
  /** ダッシュボード情報. */
  public dashboardInfos$: BehaviorSubject<BetweenTimeApiResponse> = new BehaviorSubject<BetweenTimeApiResponse>(this.dashboardEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  /** ダッシュボードの更新周期 */
  private readonly dashboadReadTime = 5 * 1000; //5秒

  constructor(
    public vehicleService: VehicleServiceProvider
  ) { }

  /**
   * 開始.
   *
   * @param parameter ダッシュボードパラメータ
   */
  start(parameter: BetweenTimeApiParameter) {
    // 初回のダッシュボード取得
    this.getDashboardInfos(parameter).subscribe(() => {
      let processing = false;
  
      this.intervalSubscription = Observable.interval(this.dashboadReadTime)
        .filter(() => !processing)
        .pipe(tap(() => processing = true))
        .flatMap(() => this.getDashboardInfos(this.parameter$.value))
        .pipe(tap(() => processing = false))
        .subscribe();
    });
  }

  /**
   * 停止.
   */
  stop() {
    // this.dashboardInfos$.next(this.dashboardEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }
    
    /**
   * ダッシュボード表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   *
   * @param parameter ダッシュボードパラメータ
   */
  private getDashboardInfos(parameter: BetweenTimeApiParameter): Observable<BetweenTimeApiResponse> {  
    return this.vehicleService.betweenTimeRequest(parameter)
    .map((response) => {
      this.dashboardInfos$.next(response);
      return this.dashboardInfos$.value;
    })
    .catch(() => Observable.of(this.dashboardInfos$.value));
  }
}



// WEBPACK FOOTER //
// ./src/providers/interval-receiver/between-interval-receiver.ts